/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-search.vue?vue&type=template&id=5c6afb52&scoped=true&"
import script from "./category-search.vue?vue&type=script&lang=js&"
export * from "./category-search.vue?vue&type=script&lang=js&"
import style0 from "./category-search.vue?vue&type=style&index=0&id=5c6afb52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6afb52",
  null
  
)

export default component.exports